export default __webpack_public_path__ + "static/Texta-Regular-webfont-2820afbe104e4a1950e723fc5d8f9f3c.woff";